var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLkExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.27mm",
    height: "41.27mm",
    viewBox: "0 0 116.99 116.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #005c8e;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.29,56.33h-38.14v-21.34L.45,58.49l40.71,23.5v-21.34h38.14v-4.33ZM9.11,58.49l27.71-16v32s-27.71-16-27.71-16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.53,30.45l-25.45-25.45L81.08,0H25.55v34.99h5V5h46.99v19.55c0,7.98,6.47,14.44,14.44,14.44h19.55v72.99H30.55v-29.99h-5v34.99h90.99V35.46l-5-5ZM91.99,33.99c-5.2,0-9.44-4.23-9.44-9.44V8.54l25.45,25.45h-16.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkExport);
export default __webpack_public_path__ + "static/media/LK_Export.e38f47a829f506a0475b61c8c31c5b55.svg";
export { ForwardRef as ReactComponent };